import React, { useRef } from "react";
import { StoryChoice, StoryScene } from "../../../story/forestRescueStory";

type StoryPageProps = {
  scene: StoryScene;
  storyTitle: string;
  feedback?: string;
  isShaking: boolean;
  onChoice: (choice: StoryChoice) => void;
};

export function StoryPage({
  scene,
  storyTitle,
  feedback,
  isShaking,
  onChoice,
}: StoryPageProps) {
  const hasChoices = Boolean(scene.choices?.length);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const playAudio = () => {
    if (!audioRef.current) {
      return;
    }

    audioRef.current.currentTime = 0;
    audioRef.current.play();
  };

  return (
    <main
      className={`story-page ${hasChoices ? "story-page-with-menu" : ""} ${
        isShaking ? "story-page-shake" : ""
      }`}
      aria-label={storyTitle}
    >
      <section
        className={`story-illustration ${scene.audio ? "story-illustration-audio" : ""}`}
        aria-label="Story picture"
        onClick={scene.audio ? playAudio : undefined}
      >
        {scene.video ? (
          <video
            className="story-media"
            src={scene.video}
            poster={scene.image}
            controls
            playsInline
          />
        ) : (
          <img className="story-media" src={scene.image} alt={`${storyTitle} ${scene.id}`} />
        )}
        {scene.audio && (
          <>
            <audio ref={audioRef} src={scene.audio} preload="auto" />
            <div className="story-audio-hint">按一下播放聲音</div>
          </>
        )}
      </section>

      {hasChoices && (
        <aside className="story-choice-panel" aria-label="Choose an answer">
          <div className="story-choice-panel-card">
            <p className="story-choice-title">Choose one</p>
            <div className="story-choice-list">
              {scene.choices?.map((choice) => (
                <button
                  key={`${scene.id}-${choice.label}`}
                  className="story-choice-button"
                  type="button"
                  onClick={() => onChoice(choice)}
                >
                  {choice.label}
                </button>
              ))}
            </div>
            {feedback && (
              <div className="story-feedback" role="alert">
                {feedback}
              </div>
            )}
          </div>
        </aside>
      )}

      {scene.text && (
        <section className="story-panel">
          <div className="story-panel-content">
            <p className="story-narration">{scene.text}</p>
          </div>
        </section>
      )}
    </main>
  );
}
